export const visit = (vm, at) => {
at({ "en": { "conversations-thread-view": { "email": { "prependReplySubject": "Re: ", "prependForwardSubject": "Fwd: ", "prependReplyAsEmailSubject": "Conversation with {{ agentName }}" } } } });
};